import { Component, ElementRef, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { FormsModule, ReactiveFormsModule, UntypedFormControl } from '@angular/forms';
import { MatDatepicker, MatDatepickerModule } from '@angular/material/datepicker';
import { MatFormFieldModule } from '@angular/material/form-field';
import { ToolsService } from 'libs/portal/src/services/tools/tools.service';
import { NgxMaterialTimepickerModule } from 'ngx-material-timepicker';

@Component({
  selector: 'app-date-time-picker',
  templateUrl: './date-time-picker.component.html',
  styleUrls: ['./date-time-picker.component.scss'],
  imports: [FormsModule, ReactiveFormsModule, MatDatepickerModule, MatFormFieldModule, NgxMaterialTimepickerModule],
  standalone: true,
})
export class DateTimePickerComponent implements OnInit {
  @Output() notify: EventEmitter<any> = new EventEmitter<string>();
  @ViewChild('elementToFocus', { static: false }) _input: ElementRef;

  dateControl = new UntypedFormControl(new Date());

  timeControl: UntypedFormControl;
  dateSelected = false;
  @Input('label') _label?: string;
  @Input() providedDate?: string | null = null;
  @Input() Morning = false;
  @Input() showTimeInput = true;
  @Input() compact: boolean = false;
  set label(l: string) {
    this._label = (l && l.trim()) || '<no name set>';
  }
  get label(): string {
    return this._label ?? '';
  }

  constructor() {}

  ngOnInit() {
    console.log(this.providedDate);

    if (this.Morning) {
      this.timeControl = new UntypedFormControl('00:00 AM');
    } else {
      this.timeControl = new UntypedFormControl('11:59 PM');
    }
    if (this.providedDate != null) {
      this.handleProvidedDateTime();
    }
    const date = this.concatDateTime(this.timeControl.value);

    this.emitRegulator(date);
  }

  handleProvidedDateTime() {
    const date = this.providedDate ? new Date(this.providedDate) : new Date()
    const hours = date.getHours();
    const minutes = date.getMinutes();
    const timeString = (hours > 12 ? hours - 12 : hours) + ':' + minutes + (hours > 12 ? ' PM' : ' AM');
    this.dateControl.setValue(date);
    this.timeControl.setValue(timeString);
  }

  formatStartDate(oldFormat: string): string {
    const theDate: Date = new Date(oldFormat);
    theDate.setHours(2, 0, 0, 0);
    return theDate.toISOString();
  }

  formatEndDate(oldFormat: string): string {
    const theDate: Date = new Date(oldFormat);
    theDate.setDate(theDate.getDate() + 1);
    theDate.setHours(1, 59, 59, 999);
    return theDate.toISOString();
  }

  emitRegulator(value: string) {
    this.notify.emit(value);
  }

  openPicker(picker: MatDatepicker<Date>) {
    picker.open();
    setTimeout(() => this._input.nativeElement.focus());
  }

  closePicker() {
    setTimeout(() => this._input.nativeElement.blur());
  }

  concatDateTime(newTime: string): string {
    let tmp = newTime.split(':');
    let hours = parseInt(tmp[0]);
    tmp = tmp[1].split(' ');
    const mins = parseInt(tmp[0]);
    const meridian = tmp[1];
    if (meridian == 'PM') {
      if (hours != 12) {
        hours += 12;
      }
    } else {
      if (hours == 12) {
        hours = 0;
      }
    }
    // let tempdate = this.dateControl.value.format("YYYY/MMM/DD")
    const date = new Date(this.dateControl.value);
    date.setHours(2, 0, 0, 0);
    // console.log(date, date.getUTCMonth(), date.getUTCDate());
    const month = date.getUTCMonth() + 1;
    const day = date.getUTCDate();
    let returnString = date.getUTCFullYear() + '-' + (month < 10 ? '0' + month : month) + '-' + (day < 10 ? '0' + day : day) + 'T';

    if (hours < 10) {
      returnString += '0';
    }
    returnString += hours + ':';
    if (mins < 10) {
      returnString += '0';
    }
    returnString += mins + ':00Z';
    return returnString;
  }

  timeChanged(newTime: string) {
    const date = this.concatDateTime(newTime);
    this.emitRegulator(date);
  }

  dateChanged() {
    const date = this.concatDateTime(this.timeControl.value);
    this.emitRegulator(date);
  }

  reset() {
    this.handleProvidedDateTime();
  }
}
